/**
 * Como uma etiqueta de skill é mostrada (AB#85634).
 *
 * A skill guarda `name:value` — o formato do cadastro de facets. Na tela vale o
 * VALOR, que é o que distingue uma etiqueta da outra: entre `area:marketing` e
 * `area:vendas`, "area" é ruído repetido em todos os selos.
 *
 * O nome não some: vai na dica, para quem precisa saber de que dimensão aquela
 * etiqueta é.
 */
export interface SkillFacetLabel {
  /** A dimensão — `area`, `squad`. */
  name: string;
  /** O valor, já legível — `Marketing`, `KitPress`. */
  value: string;
  /** Como veio do banco, para servir de chave estável. */
  raw: string;
}

const legivel = (parte: string): string =>
  parte
    .split("-")
    .filter(Boolean)
    .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    .join(" ");

export const parseSkillFacets = (facets: string[] | undefined): SkillFacetLabel[] =>
  (facets ?? [])
    .map((raw) => {
      const [name, value] = raw.split(":");
      // Entrada fora do formato é descartada em vez de virar selo sem sentido.
      // A api já valida na publicação; isto cobre dado antigo.
      if (!name || !value) return null;
      return { name: legivel(name), value: legivel(value), raw };
    })
    .filter((entry): entry is SkillFacetLabel => entry !== null);
